var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('div',[_c('awards-list',{attrs:{"awards":_vm.awards,"can-award-emoji":_vm.canAwardEmoji,"current-user-id":_vm.currentUserId,"default-awards":_vm.$options.defaultAwards,"custom-emoji-path":_vm.customEmojiPath,"selected-class":"selected"},on:{"award":_vm.handleAward}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }